// Links de pagamento - PurinCash / PerfectPay
// Clicou no plano → abre o link direto
const PAYMENT_LINKS = {
  // ===== ANDROID (direto PurinCash - link unico com selecao de opcao na pagina) =====
  "2-15dias": { link: "https://checkout.purincash.com/checkout/unlvvn59", price: 39.00 },
  "2-mensal": { link: "https://checkout.purincash.com/checkout/unlvvn59", price: 69.00 },
  "2-trimestral": { link: "https://checkout.purincash.com/checkout/unlvvn59", price: 89.00 },
  "2-permanente": { link: "https://checkout.purincash.com/checkout/unlvvn59", price: 125.00 },
  // ===== iOS (direto PurinCash - link unico com selecao de opcao na pagina) =====
  "3-15dias": { link: "https://checkout.purincash.com/checkout/n4mdsdhz", price: 39.00 },
  "3-mensal": { link: "https://checkout.purincash.com/checkout/n4mdsdhz", price: 69.00 },
  "3-trimestral": { link: "https://checkout.purincash.com/checkout/n4mdsdhz", price: 89.00 },
  "3-permanente": { link: "https://checkout.purincash.com/checkout/n4mdsdhz", price: 120.00 },
  // ===== EMULADOR (PerfectPay) =====
  "1-15dias": { link: "https://go.perfectpay.com.br/PPU38CQC29P", price: 40.00 },
  "1-mensal": { link: "https://go.perfectpay.com.br/PPU38CQ3P65", price: 65.00 },
  "1-trimestral": { link: "https://go.perfectpay.com.br/PPU38CQ3P66", price: 99.00 },
  "1-permanente": { link: "https://go.perfectpay.com.br/PPU38CQ3P69", price: 279.00 },
  // ===== BYPASS 50 PLAYERS (PerfectPay) =====
  "5-15dias": { link: "https://go.perfectpay.com.br/PPU38CQDJMO", price: 44.99 },
  "5-mensal": { link: "https://go.perfectpay.com.br/PPU38CQDJMR", price: 74.99 },
  "5-permanente": { link: "https://go.perfectpay.com.br/PPU38CQDJMS", price: 149.99 },
  // ===== AIMLESS MENU WEB (PerfectPay) =====
  "6-mensal": { link: "https://go.perfectpay.com.br/PPU38CQFGP8", price: 140.00 },
  "6-trimestral": { link: "https://go.perfectpay.com.br/PPU38CQFGP9", price: 270.00 },
  "6-permanente": { link: "https://go.perfectpay.com.br/PPU38CQFGPB", price: 550.00 }
};

export function get_payment_link(plan_id) {
  const data = PAYMENT_LINKS[plan_id];
  return data?.link || null;
}

export function get_pix_data(plan_id) {
  return PAYMENT_LINKS[plan_id] || null;
}
